module.exports = __webpack_public_path__ + "static/media/fieldWithBanners.99d18d42.svg";